export default __webpack_public_path__ + "static/media/5454.7ca49080.jpg";